import React, { useState, useEffect, useRef } from 'react';
import {
    Typography,
    Grid,
    Box,
    CssBaseline,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    TextField,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    Modal,
    Button,
} from '@mui/material';
import {
Cancel,
EditNote,
Phone,
WarningAmber
} from '@mui/icons-material';
import axios from 'axios';
import { global_link } from '../Components/Globallink';
import modalStyle from '../Components/ModalStyle';

const Contacts = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [roleFilter, setRoleFilter] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [data, setData] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [openAddContactModal, setAddContactModal] = useState(false);
  const [openBulkContactModal, setBulkContactModal] = useState(false);
  const [openDeleteContactModal, setDeleteContactModal] = useState(false);
  const [openEditContactModal, setEditContactModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadButtonStatus, setUploadButtonStatus] = useState('Submit');
  const [enableDisableButton, setEnableDisableButton] = useState('');
  const userLevel = sessionStorage.getItem("user_level")?.toLowerCase();

  const api = axios.create({baseURL: global_link});
  const authToken = process.env.AUTH_TOKEN;

  useEffect(() => {
    fetchData();
  }, [searchTerm, roleFilter, startDate, endDate, page, rowsPerPage]);

  const fetchData = async () => {
    try {
      const authyToken = localStorage.getItem(authToken);
      const response = await api.get('/contact/all', {
        params: {
          search: searchTerm,
          start_date: startDate,
          end_date: endDate,
          limit: rowsPerPage,
          offset: page * rowsPerPage,
        },
        headers: {
          Authorization: `Bearer ${authyToken}`,
        },
      });
      setData(response.data.data);
      setTotalItems(response.data.total);
    } catch (error) {
      console.error('Error fetching Contact:', error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

const copyPhoneNumber = (call_from, call_to) => {
  let call_number;
  if(call_from.length>5){
      call_number =call_from;
  }else{
      call_number =call_to;
  }
  const phoneNumber = call_number;
  const event = new CustomEvent('copyPhoneNumber', { detail: phoneNumber });
  window.dispatchEvent(event);
}

const handleCloseAddContactModal = () => {
  setAddContactModal(false);
};

const handleOpenAddContactModal = () => {
  setAddContactModal(true);
};


const handleCloseBulkContactModal = () => {
  setBulkContactModal(false);
};

const handleOpenBulkContactModal = () => {
  setBulkContactModal(true);
};

const handleOpenDeleteContactModal = () => {
  if(sessionStorage.getItem("user_level")==='supervisor' || sessionStorage.getItem("user_level")==='admin'){
    setDeleteContactModal(true);
  }
  
};

const handleCloseDeleteContactModal = () => {
  setDeleteContactModal(false);
};

const handleOpenEditContactModal = (item) => {
  setSelectedItem(item);
  setEditContactModal(true);
};

const handleCloseEditContactModal = () => {
  setEditContactModal(false);
};

const handleInputChange = (event) => {
  const { name, value } = event.target;
  // setNewDisposition({ ...newDisposition, [name]: value });
};

const handleContactSubmit = (event) => {
  event.preventDefault();
  const formData = new FormData(event.target);
  const authyToken = localStorage.getItem(authToken);
  const headers = {
      Authorization: `Bearer ${authyToken}`,
      "Content-Type": "application/json",
  };
  api.post('/contact/add', formData,{ headers, withCredentials: true})
    .then((response) => {
      handleCloseAddContactModal(false);
      fetchData();
    }).catch((error) => {console.error(error);});
}

const handleInputModChange = (event) => {
  const { name, value } = event.target;
  setSelectedItem((prevFormState) => ({
    ...prevFormState,
    [name]: value,
  }));
};

const handleContactEdit = (event) => {
  const authyToken = localStorage.getItem(authToken);
  const headers = {
      Authorization: `Bearer ${authyToken}`,
      "Content-Type": "application/json",
  };
  event.preventDefault();
  const formData = new FormData(event.target);
  api.put(`/contact/update/`, formData,{ headers, withCredentials: true})
    .then((response) => {
      fetchData();
      setEditContactModal(false);
    })
    .catch((error) => {
      console.error(error);
    });
};

const handleDeleteAllContacts = () => {
  const authyToken = localStorage.getItem(authToken);
  const headers = {
      Authorization: `Bearer ${authyToken}`,
      "Content-Type": "application/json",
  };
  api.delete(`/contact/deleteall/`, { headers, withCredentials: true})
    .then((response) => {
      setDeleteContactModal(false);
      fetchData();
    })
    .catch((error) => {
      console.error(error);
    });
}

const handleDeleteContact = (id) => {
  const authyToken = localStorage.getItem(authToken);
  const headers = {
      Authorization: `Bearer ${authyToken}`,
      "Content-Type": "application/json",
  };
  api.delete(`/contact/delete/${id}`, { headers, withCredentials: true})
    .then((response) => {
      setEditContactModal(false);
      fetchData();
    })
    .catch((error) => {
      console.error(error);
    });
}

const handleBulkContactSubmit  = async (event) => {
  event.preventDefault();
  if (!selectedFile) {
    console.log("Please select a file to upload.");
    return;
  }
  const formData = new FormData();
  formData.append("file", selectedFile);
  setEnableDisableButton('disabled');
  setUploadButtonStatus('Uploading.. Please Wait. Do Not Leave The Page');
  try {
    const authyToken = localStorage.getItem(authToken);
    const headers = {
      Authorization: `Bearer ${authyToken}`,
      "Content-Type": "multipart/form-data"
    };
    const response = await api.post("/contact/addbulk/", formData, {
            headers,
            withCredentials: true,
          });
          setBulkContactModal(false);
          fetchData();
          setEnableDisableButton('');
          setUploadButtonStatus('Submit');
    console.log(`Upload successful: ${response.data.message}`);
  } catch (error) {
    console.log(`Upload failed: ${error.response?.data?.error || error.message}`);
  }
};

// const handleBulkContactSubmit = (event) => {
//   event.preventDefault();
//   const formData = new FormData();
//   formData.append('file', selectedFile);
//   const authyToken = localStorage.getItem(authToken);
//   const headers = {
//       Authorization: `Bearer ${authyToken}`,
//       "Content-Type": "multipart/form-data"
//   };
//   api.post(`/contact/addbulk/`, formData,{
//       headers,
//       withCredentials: true,
//     })
//     .then((response) => {
//       setBulkContactModal(false);
//       fetchData();
//     })
//     .catch((error) => {
//       console.error('Error uploading file:', error);
//     });
// }

const handleFileChange = (event) => {
  setSelectedFile(event.target.files[0]);
};

const downloadTemplate = () => {
  const downloadLink = document.createElement('a');
  downloadLink.href = '/contact_template.csv';
  downloadLink.download = 'contact_template.csv';
  downloadLink.click();
};
    return (
        <>
            <CssBaseline />
            <Typography variant='h5' sx={{marginBottom:'15px'}}>
            Contacts
                </Typography>
    <Box sx={{bgcolor:'background.paper',boxShadow: 'none', border: `0.1px solid rgba(207, 211, 212, 0.2)`, borderRadius: '5px'}}>
      <Box sx={{ padding: 2, display: 'flex', gap: 2 }}>
        {/* Search Field */}
        <TextField
          label="Search"
          variant="outlined"
          value={searchTerm}
          onChange={handleSearchChange}
          placeholder="Search"
          fullWidth
        />
                  <Button
    variant="contained"
    sx={{width:'30%!important'}}
    type="submit"
    color='primary'
    onClick={handleOpenAddContactModal}

  >
    Add Contact
  </Button>
          <Button
    variant="contained"
    sx={{width:'30%!important'}}
    type="submit"
    color='info'
    onClick={handleOpenBulkContactModal}

  >
    Bulk
  </Button>
  {data.length > 0 ? ( 
    <>
  <Button
    variant="contained"
    sx={{width:'30%!important',display: userLevel === 'agent' ? 'none' : 'block'}}

    type="submit"
    color='error'
    onClick={handleOpenDeleteContactModal}

  >
    Delete All
  </Button></>):(<></>)}
      </Box>
            <TableContainer>
        <Table sx={{ fontSize: '5.1rem !important' }} size="small">
          {/* Table Head */}
          <TableHead sx={{bgcolor:'background.table',width:'100%'}}>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Phone Number</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Date</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>

          {/* Table Body */}
          <TableBody>
          {data.length > 0 ? (
              data.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.phone_number}</TableCell>
                  <TableCell>{row.email}</TableCell>
                  <TableCell>{row.date}</TableCell>
                  <TableCell align="center">
                    <Button variant='contained' title="Contact" color="success" onClick={() => copyPhoneNumber(row.phone_number)}><Phone /></Button>
                    <Button variant='contained' title="Edit" color="warning" sx={{marginLeft:'10px'}} onClick={() => handleOpenEditContactModal(row)}><EditNote /></Button>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  No matching records found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <TablePagination
        component="div"
        count={totalItems}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[10, 50, 100]}
        labelRowsPerPage="Rows per page"
      />

<Modal
                open={openAddContactModal}
                onClose={handleCloseAddContactModal}
                aria-labelledby="modal-title"
                aria-describedby="modal-contact"
            >
                <Box sx={modalStyle}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <h3 id="modal-title">Add Contact</h3>
                        <Box display="flex" justifyContent="right">
                            <Cancel onClick={handleCloseAddContactModal} sx={{ cursor: 'pointer' }} />
                        </Box>
                        </Box>
 <form onSubmit={handleContactSubmit}>
          <Grid container spacing={1}>

          <Grid item xs={6}>
            
<TextField
              label="Name"
              name="name"
              onChange={handleInputChange}
              fullWidth
              variant="outlined"
              required="true"
              sx={{marginTop:"5px"}}
            />
          </Grid>
          <Grid item xs={6}>
<TextField
          label="Phone Number"
          placeholder="Phone Number"
          variant="outlined"
          fullWidth
          name="phone_number"
          required="true"
          sx={{marginTop:"5px"}}
        />
</Grid>
<Grid item xs={6}><TextField
          label="Alternative Phone Number"
          placeholder="Alternative Phone Number"
          variant="outlined"
          fullWidth
          name="alternative_phone_number"
          sx={{marginTop:"5px"}}
        /></Grid>


<Grid item xs={6}><TextField
          label="Email"
          placeholder="Email"
          variant="outlined"
          fullWidth
          name="email"
          sx={{marginTop:"5px"}}
        /></Grid>

<Grid item xs={6}><TextField
          label="Business"
          placeholder="Business"
          variant="outlined"
          fullWidth
          name="business"
          sx={{marginTop:"5px"}}
        /></Grid>

<Grid item xs={6}><TextField
          label="Home"
          placeholder="Home"
          variant="outlined"
          fullWidth
          name="home"
          sx={{marginTop:"5px"}}
        /></Grid>

<Grid item xs={12}><TextField
          label="department"
          placeholder="Department"
          variant="outlined"
          fullWidth
          name="department"
          sx={{marginTop:"5px"}}
        /></Grid>

<Grid item xs={12}>
<Button type="submit" variant="contained" color='info' sx={{padding:"10px",marginTop:"10px",width:"100%"}}>Add Contact</Button>
</Grid>

            </Grid>
          </form>

                    
                </Box>
</Modal>

<Modal
                open={openBulkContactModal}
                onClose={handleCloseBulkContactModal}
                aria-labelledby="modal-title"
                aria-describedby="modal-contact"
                BackdropProps={{
                  onClick: (event) => event.stopPropagation(),
                }}
            >
                <Box sx={modalStyle}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <h3 id="modal-title">Add Bulk Contact</h3>
                        <h3 id="modal-title"><Button variant="contained" sx={{marginTop:"-10px!important"}} onClick={downloadTemplate}>Download Template</Button></h3>
                        <Box display="flex" justifyContent="right">
                            <Cancel onClick={handleCloseBulkContactModal} sx={{ cursor: 'pointer' }} />
                        </Box>
                    </Box>

                    <form onSubmit={handleBulkContactSubmit}>
          <Grid container spacing={1}>
<Grid item xs={12}>
            <TextField
              name="file"
              type="file"
              onChange={handleFileChange}
              fullWidth
              sx={{marginTop:"10px"}}
              variant="outlined"
              required="true"
              accept=".csv, .xlsx"
            />
</Grid>

<Grid item xs={12}>
            <Button type="submit" variant="contained" color="info" disabled={enableDisableButton} sx={{padding:"10px",marginTop:"10px",color:'white'}}>{uploadButtonStatus}</Button>
            </Grid>

            </Grid>
          </form>
                </Box>
</Modal>

<Modal
                open={openDeleteContactModal}
                onClose={handleCloseDeleteContactModal}
                aria-labelledby="modal-title"
                aria-describedby="modal-contact"
            >
                <Box sx={modalStyle}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <h3 id="modal-title">Delete All Contact</h3>
                        <Box display="flex" justifyContent="right">
                            <Cancel onClick={handleCloseDeleteContactModal} sx={{ cursor: 'pointer' }} />
                        </Box>
                    </Box>
                    <Box justifyContent="center" textAlign="center">
<h3 id="modal-title"><WarningAmber sx={{fontSize:'70px', color:'red'}}/> <br/> Are You Sure You Want to Delete All Contacts?<br/> This action is irreversible.</h3>
</Box>
          


<Grid item xs={12} display="flex" justifyContent="space-between">
  <Box><Button type="submit" variant="contained" sx={{padding:"10px",marginTop:"10px",color:'white',cursor:"pointer"}} onClick={handleCloseDeleteContactModal}>No</Button></Box>
  {sessionStorage.getItem("user_level") === "supervisor" && (
        <Box><Button type="submit" variant="contained" sx={{padding:"10px",marginTop:"10px",color:'white',backgroundColor: 'red'}} onClick={handleDeleteAllContacts}>Delete</Button></Box> )}
            
            </Grid>

                </Box>
</Modal>

<Modal
                open={openEditContactModal}
                onClose={handleCloseEditContactModal}
                aria-labelledby="modal-title"
                aria-describedby="modal-contact"
            >
                <Box sx={modalStyle}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <h3 id="modal-title">Edit Contact - {selectedItem && (selectedItem.phone_number)}</h3>
                        <Box display="flex" justifyContent="right">
                            <Cancel onClick={handleCloseEditContactModal} sx={{ cursor: 'pointer' }} />
                        </Box>
                    </Box>
                    <form onSubmit={handleContactEdit}>
                    {selectedItem && (
          <Grid container spacing={1}>
          <Grid item xs={6}>

          <TextField    type="hidden"
              name="id"
              value={selectedItem.id}
              style={{ display: 'none' }}
              required="true"
            />
            
<TextField
              label="Name"
              name="name"
              onChange={handleInputModChange}
              fullWidth
              variant="outlined"
              // required="true"
              sx={{marginTop:"5px"}}
              value={selectedItem.name || ""}
            />
          </Grid>
          <Grid item xs={6}>
<TextField
          label="Phone Number"
          placeholder="Phone Number"
          variant="outlined"
          fullWidth
          name="phone_number"
          onChange={handleInputModChange}
          // required="true"
          sx={{marginTop:"5px"}}
          value={selectedItem.phone_number || ""}
        />
</Grid>
<Grid item xs={6}><TextField
          label="Alternative Phone Number"
          placeholder="Alternative Phone Number"
          variant="outlined"
          fullWidth
          name="alternative_phone_number"
          onChange={handleInputModChange}
          sx={{marginTop:"5px"}}
          value={selectedItem.alternative_phone_number || ""}
        /></Grid>

<Grid item xs={6}><TextField
          label="Email"
          placeholder="Email"
          variant="outlined"
          fullWidth
          name="email"
          onChange={handleInputModChange}
          sx={{marginTop:"5px"}}
          value={selectedItem.email || ""}
        /></Grid>

<Grid item xs={6}><TextField
          label="Business"
          placeholder="Business"
          variant="outlined"
          fullWidth
          name="business"
          onChange={handleInputModChange}
          sx={{marginTop:"5px"}}
          value={selectedItem.business || ""}
        /></Grid>

<Grid item xs={6}><TextField
          label="Home"
          placeholder="Home"
          variant="outlined"
          fullWidth
          name="home"
          onChange={handleInputModChange}
          sx={{marginTop:"5px"}}
          value={selectedItem.home || ""}
        /></Grid>

<Grid item xs={12}><TextField
          label="department"
          placeholder="Department"
          variant="outlined"
          fullWidth
          name="department"
          onChange={handleInputModChange}
          sx={{marginTop:"5px"}}
          value={selectedItem.department || ""}
        /></Grid>

{/* If user is an agent, this takes 12 units (full width). Otherwise, 6. */}

<Grid item xs={userLevel === 'agent' ? 12 : 6}>
  <Button 
    type="submit" 
    variant="contained" 
    color='info' 
    sx={{ padding: "10px", marginTop: "10px", width: "100%" }}
  >
    Update
  </Button>
</Grid>

{/* Only renders if user is NOT an agent */}
{userLevel !== 'agent' && (
  <Grid item xs={6}>
    <Button 
      type="button" 
      variant="contained" 
      color='error' 
      sx={{ padding: "10px", marginTop: "10px", width: "100%" }} 
      onClick={() => handleDeleteContact(selectedItem.id)}
    >
      Delete
    </Button>
  </Grid>
)}
            </Grid>)}
          </form>
    </Box>
</Modal>
      </Box>
            </>
    );
};

export default Contacts;